import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import {getTopic} from '../topic/list/core/_requests';
import PackagesTable from './PackagesTable'
import { listApplicationUser as listCreator } from '../applicationuser/list/core/_requests'
import { listApplicationUser as listReviewer } from '../applicationuser/list/core/_requests'
import { createPackage } from '../package/list/core/_requests';

const CreatePackages = () => {
    const { state } = useLocation();
    const [packages, setPackages] = useState([]);
    const [creators, setcreators] = React.useState([])
    const [reviewers, setreviewers] = React.useState([])
    const [technicalreviewers, settechnicalreviewers] = React.useState([])
    const [watchers, setwatchers] = React.useState([])

    const savePackages = async (formValues) => {
         /*for (let pkg of formValues) {
    const { name, numberOfQuestions, creatorId, reviewerId, topicId, isJsonCreated, requestId } = pkg;
    if (!name || !numberOfQuestions || !creatorId || !reviewerId || !topicId || isJsonCreated === undefined || !requestId) {
      alert('Tüm alanlar dolu olmalıdır.');
      return; // Eksik bilgi varsa fonksiyonu sonlandır.
    }
  }*/

  const preparedPackages = formValues.map(pkg => ({
        name: pkg.name,
        numberOfQuestions: parseInt(pkg.questionCount, 10), // Sayısal değere dönüştür
        creatorId: pkg.creatorId,
        reviewerId: pkg.reviewerId,
        technicalReviewerId: pkg.technicalReviewerId,
        watcherId: pkg.watcherId,
        topicId: pkg.id,  // Bu örnekte pkg.guid doğruysa
        isJsonCreated: false,  // Statik değer
        requestId: state.requestId  // Dışarıdan alınan ekstra veri
    }));
    console.log(preparedPackages)
  // Tüm kontrol geçerliyse, her bir paketi sunucuya gönder.
  const savePromises = preparedPackages.map(pkg => createPackage(pkg));

    try {
        const results = await Promise.all(savePromises);
        console.log('Tüm paketler başarıyla kaydedildi:', results);
        alert('Tüm paketler başarıyla kaydedildi.');
    } catch (error) {
        console.error('Paket kaydetme işlemi sırasında hata oluştu:', error);
        alert('Paket kaydetme işlemi sırasında hata oluştu.');
    }
    };

    useEffect(() => {
        listCreator("Id,Name,SurName").then((res: any) => {
            setcreators(res.data || [])
        })
        listReviewer("Id,Name,SurName").then((res: any) => {
            setreviewers(res.data || [])
        })
        listReviewer("Id,Name,SurName").then((res: any) => {
            settechnicalreviewers(res.data || [])
        })
        listReviewer("Id,Name,SurName").then((res: any) => {
            setwatchers(res.data || [])
        })
    }, [])

    useEffect(() => {
        const fetchPackages = async () => {
            try {
                const promises = state.jsonData.map(item =>
                    getTopic(`filter_guidString=${item.Id}`, "Id,Name, Guid")
                );
                const results = await Promise.all(promises);
                // Her bir sonucun dönüş yapısı QueryResponse olduğundan, doğrudan kullanabiliriz
                console.log(results);
                setPackages(results.flatMap(result => result.data)); // Varsa items array'ini düzleştir
            } catch (error) {
                console.error('Package bilgileri çekilirken hata oluştu', error);
            }
        };

        if (state.jsonData) {
            fetchPackages();
        }
    }, [state.jsonData]);

     useEffect(() => {
       console.log(state.requestId);

    }, [state]);

    useEffect(() => {
        console.log(packages);
    }, [packages])

    return (
        <div>
            <h1>Paket Tanımlama</h1>
            <PackagesTable packages={packages} creators={creators} reviewers={reviewers} technicalReviewers={technicalreviewers} watchers={watchers} savePackages={savePackages} />
        </div>
    );
}

export default CreatePackages;
